// partenaire-mapper.service.ts
import { Injectable } from '@angular/core';
import Parrain from 'config/parrain';
import Partenaire from 'app/components/partenaire/partenaire.model';

@Injectable({
    providedIn: 'root'
})
export class PartenaireMapperService {

    mapToParrain(partenaire: Partenaire): Parrain {
        return {
            id: partenaire.id || '',
            name: partenaire.name || '',
            fullname: partenaire.name || '', // Utiliser name comme fullname si pas d'autre choix
            country: partenaire.country || '',
            city: partenaire.city || '',
            street: partenaire.street || '',
            zipcode: partenaire.zipcode || '',
            phoneNumber: partenaire.phone_number || '',
            urlWebSite: partenaire.website_url || '',
            isMainSponsor: partenaire.is_main_sponsor || false,
            
            // Mapper le logo - IMPORTANT : utiliser logo_sponsor directement dans l'URL
            logo: {
                id: partenaire.id || '',
                url: partenaire.logo_sponsor || '', // URL complète depuis la DB
                urlExt: '', // Pas besoin d'extension pour les URLs complètes
                extension: '', // Pas besoin d'extension pour les URLs complètes
            },
            
            // Styles par défaut adaptés au contexte
            styles: {
                logo: {
                    size: {
                        sidebarLeftBottom: {
                            classnameWidth: 'w-24',
                            classnameHeight: 'h-auto',
                            width: 96,
                            height: 0,
                        },
                        bottomBarRight: {
                            classnameWidth: 'w-8',
                            classnameHeight: 'h-fit',
                        },
                        advertising: {
                            classnameWidth: 'w-24',
                            classnameHeight: 'h-auto',
                        },
                        bannerSide: { 
                            classnameWidth: 'w-18', 
                            classnameHeight: 'h-auto' 
                        },
                        bannerFeed: { 
                            classnameWidth: 'w-20', 
                            classnameHeight: 'h-auto' 
                        },
                        partnerPlace: { 
                            classnameWidth: 'w-22', 
                            classnameHeight: 'h-auto' 
                        },
                    },
                },
            },
            
            // Personnalisation par défaut selon le type de sponsor
            customize: {
                needBackground: partenaire.is_main_sponsor ? true : false,
                backgroundColor: partenaire.is_main_sponsor ? 'bg-white' : 'bg-gray-50',
                padding: partenaire.is_main_sponsor ? 'p-1' : 'p-0.5',
                borderRounded: true
            }
        };
    }

    // Méthode helper pour mapper plusieurs partenaires
    mapToParrains(partenaires: Partenaire[]): Parrain[] {
        return partenaires.map(p => this.mapToParrain(p));
    }

    // Méthode pour mapper seulement les sponsors principaux
    mapMainSponsorsToParrains(partenaires: Partenaire[]): Parrain[] {
        return partenaires
            .filter(p => p.is_main_sponsor)
            .slice(0, 5) // Limiter à 5 max
            .map(p => this.mapToParrain(p));
    }
}